<template>
  <div class="app-safe">
    <div class="app-safe-filter">
      <div class="app-safe-filter-select">
        <a-select
          ref="select"
          style="width: 160px"
          :value="level"
          :options="selectOption"
          @change="handleSelectChange"
        >
        </a-select>
      </div>
      <div class="app-safe-filter-tabs">
        <a-radio-group v-model:value="deviceType" @change="handleDeviceType">
          <a-radio-button value="android">
            <android-outlined />
            Android
          </a-radio-button>
          <a-radio-button value="ios">
            <apple-outlined />
            iOS
          </a-radio-button>
        </a-radio-group>
      </div>
      <div class="app-safe-filter-datepicker">
        <RangePicker
          @dataPickerTime="selectTime"
          :defaultDate="defaultDate"
          :timeFrame="90"
        />
      </div>
      <span class="search-btn search-btn-primary" @click="handleDownLoad">
        下载统计数据
      </span>
      <div class="downLoad-info">
        <a-tooltip>
          <template #title>
            将统计当前所选app类型和时间区间筛选条件下的风险数据，但风险等级数据将全部导出
          </template>
          <InfoCircleOutlined />
        </a-tooltip>
      </div>
    </div>
    <div class="app-safe-top">
      <div class="app-safe-card">
        <span class="card-title">漏洞风险类型</span>
        <div class="app-safe-chartbox">
          <Card-border></Card-border>
          <PieChart :pieData="vulData" :domId="`appSafeRiskType`" />
        </div>
      </div>
      <div class="app-safe-card">
        <span class="card-title">漏洞风险分布</span>
        <div class="app-safe-chartbox">
          <Card-border></Card-border>
          <PieChart :pieData="vulDetailData" :domId="`appSafeRiskDis`" />
        </div>
      </div>
      <div class="app-safe-card">
        <span class="card-title">漏洞风险应用分布TOP 50</span>
        <div class="app-safe-chartbox">
          <Card-border></Card-border>
          <PieChart :pieData="riskApp50" :domId="`appSafeRisk50`" />
        </div>
      </div>
    </div>
    <div class="app-safe-bottom">
      <div class="app-safe-card">
        <span class="card-title">检出风险数量变化</span>
        <div class="app-safe-chartbox">
          <Card-border></Card-border>
          <LineChart :data="trendData" :chartIndex="0" />
        </div>
      </div>
      <div class="app-safe-card">
        <span class="card-title">风险应用 TOP 10</span>
        <div class="app-safe-chartbox">
          <Card-border></Card-border>
          <BarChart
            :barData="riskAppNum"
            :barDataLegend="riskLabel"
            :barXLabel="riskAppName"
            :totalDataTotal="riskAppNumTotal"
            :chartIndex="`appTop10`"
          ></BarChart>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { ref, reactive } from 'vue';
import dayjs from 'dayjs';
import { getAnalysis, getDownLoad } from '@/api/appSafe.js';
import { Select, Tooltip } from 'ant-design-vue';
import LineChart from './common/lines.vue';
import BarChart from './common/bar.vue';
import CardBorder from '@/components/common/card-border.vue';
import RangePicker from '@/components/common/range-picker.vue';
import PieChart from './common/pie-chart.vue';
import { getImgPath } from '@/utils/addColor.js';
import { AppleOutlined, AndroidOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'Application',
  components: {
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    CardBorder,
    RangePicker,
    PieChart,
    LineChart,
    BarChart,
    AppleOutlined,
    AndroidOutlined,
    InfoCircleOutlined
  },
  setup() {
    //演示数据用
    const defaultDate = localStorage.rangeDate?.split(',') || [dayjs().subtract(1, "day"), dayjs().subtract(7, "day")];
    let monday = dayjs(defaultDate[0]).format("YYYY-MM-DD");
    let sunday = dayjs(defaultDate[1]).format("YYYY-MM-DD");
    const level = ref('total');
    const allData = ref({});
    const selectOption = ref([
      { label: '全部', value: 'total', level: 'total' },
      { label: '高危', value: "high", level: 3 },
      { label: '中危', value: "middle", level: 2 },
      { label: '低危', value: "low", level: 1 },
    ]);
    const vulData = ref([]);//漏洞风险类型
    const vulDetailData = ref([]); //漏洞风险分布
    const riskApp50 = ref([]);
    const trendData = ref([]);
    const riskAppNum = ref([]);
    const riskAppName = ref([]);
    const riskLabel = ref([
      "高危", "中危", "低危"
    ]);
    const deviceType = ref('android');

    const timePicker = reactive({
      st: monday,
      et: sunday,
      dt: monday
    });
    const handleSelectChange = (val) => {
      level.value = val;
      let params = {
        starttime: timePicker.st,
        endtime: timePicker.et
      };
      getAnalysisData(params);
    };
    const handleDeviceType = (e) => {
      const val = e.target.value;
      deviceType.value = val;
      getChartData();
      getRiskChartData();
    };
    // 日历选择
    const selectTime = (val) => {
      if (val) {
        monday = dayjs(val[0]).format("YYYY-MM-DD");
        sunday = dayjs(val[1]).format("YYYY-MM-DD");
        timePicker.st = monday;
        timePicker.et = sunday;
        let params = {
          starttime: monday,
          endtime: sunday
        };
        getAnalysisData(params);
      }

    };
    // 下载数据
    const handleDownLoad = () => {
      let params = {
        type: deviceType.value === 'android' ? 1 : 2,
        starttime: timePicker.st,
        endtime: timePicker.et,
      };
      getDownLoad(params);
    };
    const getAnalysisData = async (params) => {
      const { data } = await getAnalysis(params || {});
      allData.value = { ...data };
      getChartData();
      getRiskChartData();
    };
    const getRiskChartData = () => {
      const vulDetailLevel = selectOption.value.find((item) => {
        return item.value === level.value;
      });
      //漏洞风险类型
      vulData.value = allData.value[deviceType.value].vul.map((item, index) => {
        let obj = {
          "name": item.name, "value": item[level.value]
        };
        if (index === 0) {
          obj.label = { show: true };
        }
        return obj;
      });
      //漏洞风险分布
      const vulDetailFilterData = allData.value[deviceType.value].vulDetail.filter((item) => {
        if (vulDetailLevel.level === 'total') {
          return item;
        }
        if (item.level == vulDetailLevel.level) {
          return item;
        }
      });
      vulDetailData.value = vulDetailFilterData ? vulDetailFilterData.map((item, index) => {
        let obj = {
          "name": item.name, "value": item.total
        };
        if (index === 0) {
          obj.label = { show: true };
        }
        return obj;
      }) : [];
    };
    const getChartData = () => {
      //漏洞风险应用分布TOP 50
      riskApp50.value = allData.value[deviceType.value]["app"].map((item, index) => {
        let obj = {
          "name": item.app_name, "value": item[level.value]
        };
        if (index === 0) {
          obj.label = { show: true };
        }
        return obj;
      });
      //检出风险数量变化
      trendData.value = allData.value[deviceType.value].trend.map((item) => {
        return {
          "name": item.time, "value": item[level.value]
        };
      });

      const highData = [];
      const middleData = [];
      const lowData = [];
      const appNameArr = [];
      allData.value[deviceType.value]["appTop10"].forEach(item => {
        appNameArr.push(item.app_name);
        highData.push(item.high);
        middleData.push(item.middle);
        lowData.push(item.low);
      });
      const newData = [highData, middleData, lowData];
      riskAppNum.value = newData;
      riskAppName.value = appNameArr;
    };

    getAnalysisData({
      starttime: monday,
      endtime: sunday
    });
    return {
      level,
      selectOption,
      handleSelectChange,
      handleDeviceType,
      handleDownLoad,
      vulData,
      vulDetailData,
      riskApp50,
      trendData,
      riskAppNum,
      riskAppName,
      riskLabel,
      selectTime,
      getImgPath,
      defaultDate,
      deviceType
    };
  },
}
  </script>
  
  <style  lang="less">
@import url('./index.less');
</style>
  